import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function ScrollIndicator() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // 滚动超过 100px 后隐藏
      if (window.scrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          onClick={handleClick}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 8 }}
          transition={{ duration: 0.4, ease: [0.32, 0.72, 0, 1] }}
          className="fixed bottom-8 left-1/2 z-40 -translate-x-1/2"
          aria-label="向下滚动查看更多"
        >
          {/* Pill container with warm border + glass */}
          <span className="flex flex-col items-center gap-1.5 rounded-full border border-[#1414131a] dark:border-[#faf9f51a] bg-[#faf9f5]/70 dark:bg-[#141413]/70 px-3 py-2.5 shadow-warm-sm backdrop-blur-sm transition-all duration-300 ease-spring hover:border-[#ae5630]/40 hover:shadow-warm">
            {/* Animated scroll line */}
            <span className="relative h-4 w-px overflow-hidden rounded-full bg-[#1414131a] dark:bg-[#faf9f51a]">
              <motion.span
                className="absolute top-0 left-0 h-1.5 w-px rounded-full bg-[#ae5630]"
                animate={{ y: ['-100%', '400%'] }}
                transition={{ duration: 1.4, ease: 'easeInOut', repeat: Infinity, repeatDelay: 0.3 }}
              />
            </span>
            {/* Clay dot */}
            <span className="h-1 w-1 rounded-full bg-[#ae5630]/50" />
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
